/*
 * File Created: Thursday, 8th June 2023 1:44:50 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

function ImagePreviewSkeleton(): JSX.Element {
  return (
    <Box
      sx={{
        width: { xs: "100%", md: "50%", xl: "600px" },
        height: "100%",
        // backgroundColor: "greenyellow",
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        justifyContent: "space-between",
        gap: { xs: 1 },
      }}
    >
      <Box
        sx={{
          width: {xs: "100%", md: "90px", lg: "115px" },
          height: "auto",
          maxHeight: {xs: "auto", lg: "611px", xl: "618px"},
          overflow: "auto",
          // backgroundColor: "indigo",
          display: "flex",
          gap: 1,
          flexDirection: {xs: "row", md: "column"}
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            width: {xs: "80px", md: "100%"},
            height: {xs: "80px", sm: "116px", md: "120px", lg: "142px" },
          }}
        />
      </Box>
      <Skeleton
        variant="rectangular"
        sx={{
          width: { xs: "100%", md: "calc(100% - 95px)" },
          height: {
            xs: "463px",
            sm: "496px",
            md: "522px",
            lg: "611px",
            xl: "618px",
          },
        }}
      />
    </Box>
  );
}

export default ImagePreviewSkeleton;
